import { Component, Injector, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/shared/baseComponent';

@Component({
  selector: 'app-configtable',
  templateUrl: './configtable.component.html',
  styleUrls: ['./configtable.component.css']
})
export class ConfigtableComponent extends BaseComponent implements OnInit {

  config: any = {}
  constructor(injector: Injector) {super(injector) }

  async ngOnInit() {
    this.config = await this.db.get("config","getConfig")
  }

  async post(){
    await this.db.post("config","postConfig",this.config)
    this.config = await this.db.get("config","getConfig")
    this.toast.success("Config updated")
  }

}
